<template>
  <div id="app" v-wechat-title='$route.meta.title'>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  computed: {
    showOverlay() {
      return true;
    },
  },
  created(){
   
    // const pageUrl = window.location.href.split('#')[0];
    //   getWxConfig(
    //     { pageUrl },
    //     (res) => {
    //       wx.config({
    //         debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //         appId: res.data.appId, // 必填，公众号的唯一标识
    //         timestamp: res.data.timestamp, // 必填，生成签名的时间戳
    //         nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
    //         signature: res.data.signature, // 必填，签名
    //         jsApiList: ["openLocation", "getLocation"], // 必填，需要使用的JS接口列表
    //         openTagList: ['wx-open-launch-weapp']
    //       });
    //     },
    //     (err) => {}
    //   );
  }
};
</script>
<style>
#app {
  min-height: 100%;
  overflow-y: auto;
  background: #F6F6F6;
}
.van-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
